import { Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef, HostListener } from "@angular/core";
import { DatePipe, DecimalPipe } from "@angular/common";
import { ExportExcelService } from "../../shared/services/export-excel.service";
import { ActivatedRoute } from "@angular/router";
import { CommonDataService } from "../../shared/services/common-data.service";
import { IMyOptions } from "mydatepicker";
import { ToastrService } from "ngx-toastr";
import { ApiService } from "../../shared/services/api.service";
import { Urls } from "../../utils/urls";
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map , startWith} from 'rxjs/operators'
import * as moment from 'moment';
import { hrtime } from 'process';
import { From_date, To_date} from  '@root/app.constant';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';


@Component({
  selector: "app-nav-dividends",
  templateUrl: "./nav-dividends.component.html",
  styleUrls: ["./nav-dividends.component.scss"],
})
export class NavDividendsComponent implements OnInit {
  
  noData !: string;

  today = new Date();

  schemeControl = new FormControl({'scheme':'All'});

  @ViewChildren(MatAutocompleteTrigger) autocompleteTriggers!: QueryList<MatAutocompleteTrigger>; 
  @HostListener('window:scroll') onScroll() { this.autocompleteTriggers.forEach(trigger => { if (trigger.panelOpen) { trigger.closePanel(); } }); }

  liveMessage = '';

  public myDatePickerOptionsFrom: IMyOptions = {
    dateFormat: "dd mmm yyyy",
    editableDateField: false,
  };
  public myDatePickerOptionsTo: IMyOptions = {
    dateFormat: "dd mmm yyyy",
    editableDateField: false,
  };

  activeTab = "nav";

  activeTabSub = "current";

  @ViewChildren('mainTab')
mainTabs!: QueryList<ElementRef>;

@ViewChild('tableResults')
tableResults!: ElementRef;

mainTabList = ['nav', 'dividends'];

@ViewChildren('subTab')
subTabs!: QueryList<ElementRef>;

subTabList = ['current', 'historic'];

  userData = {
    scheme: "All",
    plan: "All",
    fromDate: new Date().toISOString(),
    toDate: new Date().toISOString(),
  };
  
  planList:any[] = [];

  schemeList:any[] = [];

  filteredSchemeList!: Observable<any[]>;

  data:any[] = [];
  pageSize:number = 5;
  currentPage:any = 1;
  currentPageNav:any = 1;
  currentPageTab:any = 1;
  currentPageMobile:any = 1;
  isMobile = false;
  constructor(
    public exportExcel: ExportExcelService,
    public route: ActivatedRoute,
    private commonDataService: CommonDataService,
    private toastr: ToastrService,
    public apiService: ApiService
  ) {}

  ngOnInit() {
    this.isMobile = window.innerWidth < 768;
    this.getScheme();
    this.scrollTop();
    this.setCurrentDate();
    setTimeout(() => { this.setPaginationAriaCurrent(); });
    this.schemeControl.valueChanges.subscribe(
      (value:any)=>{
        const schemeList = this._filter(value);
        this.filteredSchemeList= new Observable(ob => {ob.next(schemeList); })
      }
    );
  }
  pageChanged(event: number,type:string): void {
    switch(type){
      case 'current':{
        this.currentPage = event;
        break;
      }
      case 'mobile':{
        this.currentPageMobile = event;
        break;
      }
      case 'tab':{
        this.currentPageTab = event;
        break;
      }
      case 'nav':{
        this.currentPageNav = event;
        break;
      }
    }
   setTimeout(() => { this.setPaginationAriaCurrent(); if (this.tableResults) { this.tableResults.nativeElement.focus(); } });
    
  }
  private _filter(value: string): any[] {
    let filterValue = '';
    if (value && typeof value === 'string') {
      filterValue = value.toLowerCase();
    }
    //const filterValue = value ? value+''.toLowerCase() : '';
    return this.schemeList.filter((item:any) => item.scheme.toLowerCase().includes(filterValue));
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  setCurrentDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    const obj = this.getCopyOfOptions(this.myDatePickerOptionsTo);
    obj.disableSince = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    };
    this.myDatePickerOptionsTo = obj;
    this.myDatePickerOptionsFrom = obj;
  };

  public onSchemeChange(event: MatAutocompleteSelectedEvent){
    this.userData.scheme = event.option.value ? event.option.value.scheme : '';
    this.getPlan(this.userData.scheme)
  }

  getScheme = () => {
    let url;
    if (this.activeTab === "nav") {
      url = Urls.getSchemeNav;
    } else {
      url = Urls.getSchemeDiv;
    }
    this.apiService.getData(url).subscribe((response: any) => {
      var schemeList = response.data.schemeList;
      if(this.activeTabSub === "current" && this.activeTab ==='nav'){
        const targetScheme = "ITI Conservative Hybrid Fund".toLowerCase();
        schemeList = schemeList.filter((item:any) => item.scheme.trim().toLowerCase() !== targetScheme);
      }
     
      this.schemeList =  [{scheme: 'All'} , ...schemeList];
      this.filteredSchemeList= new Observable(ob => {ob.next(this.schemeList); })
      this.getPlan(this.userData.scheme);
    });
  };

  getPlan = (scheme:string ) => {
    let url;
    if (this.activeTab === "nav") {
      url = Urls.getPlanNav;
    } else {
      url = Urls.getPlanDiv;
    }
    const _scheme = scheme ? scheme : 'All';
    this.apiService.postData(url, {"scheme": _scheme}).subscribe((response: any) => {
      const planList = response.data.planList;
      this.planList = [{'plan': 'All'}, ...planList]
      this.getTableData();
    });
  };

  getTableData = () => {
    let url;
    if (this.activeTab === "nav") {
      if (this.activeTabSub === "current") {
        url = Urls.getCurrentNav;
      } else {
        url = Urls.getHistoricNav;
      }
    } else {
      if (this.activeTabSub === "current") {
        url = Urls.getCurrentDividend;
      } else {
        url = Urls.getHistoricDividend;
      }
    }

    if (this.activeTabSub === "current") {
      // delete this.userData.fromDate;
      // delete this.userData.toDate;
    } 

    const requestData = JSON.parse(JSON.stringify(this.userData));

    if (this.userData.plan === "All") {
      requestData.plan = "";
    }
    if (this.userData.scheme === "All") {
      requestData.scheme = "";
    }
    
    this.apiService.postData(url, requestData).subscribe((response: any) => {
      this.data = response.data.returnList;
    });
  };

  setActive = (val:string) => {
    this.resetData();
    this.activeTab = val;
    this.getScheme();
    this.getTableData();
  };

  onMainTabKeydown(event: KeyboardEvent, index: number) {

  let newIndex = index;

  switch (event.key) {

    case 'ArrowRight':
      event.preventDefault();
      newIndex = (index + 1) % this.mainTabList.length;
      break;

    case 'ArrowLeft':
      event.preventDefault();
      newIndex = (index - 1 + this.mainTabList.length) % this.mainTabList.length;
      break;

    case 'Home':
      event.preventDefault();
      newIndex = 0;
      break;

    case 'End':
      event.preventDefault();
      newIndex = this.mainTabList.length - 1;
      break;

    case 'Enter':
    case ' ':
      event.preventDefault();
      this.setActive(this.mainTabList[index]);
      return;

    default:
      return;
  }

  this.setActive(this.mainTabList[newIndex]);

  setTimeout(() => {
    this.mainTabs.toArray()[newIndex].nativeElement.focus();
  });
}
setPaginationAriaCurrent() {

  const paginationLinks =
    document.querySelectorAll('.ngx-pagination a');

  paginationLinks.forEach((link: any) => {
    link.setAttribute('role', 'link');

    const page =
      link.textContent?.trim();

    if (page) {
      link.setAttribute(
        'aria-label',
        `Go to page ${page}`
      );
    }
  });

  const currentPages =
    document.querySelectorAll('.ngx-pagination li.current');

  currentPages.forEach((item: any) => {
    item.setAttribute('aria-current', 'page');

    const pageNumber =
      item.textContent
        ?.replace("You're on page", '')
        .trim();

    item.setAttribute(
      'aria-label',
      `Current page, Page ${pageNumber}`
    );
  });
}

onSubTabKeydown(event: KeyboardEvent, index: number) {

  let newIndex = index;

  switch (event.key) {

    case 'ArrowRight':
      event.preventDefault();
      newIndex = (index + 1) % this.subTabList.length;
      break;

    case 'ArrowLeft':
      event.preventDefault();
      newIndex = (index - 1 + this.subTabList.length) % this.subTabList.length;
      break;

    case 'Home':
      event.preventDefault();
      newIndex = 0;
      break;

    case 'End':
      event.preventDefault();
      newIndex = this.subTabList.length - 1;
      break;

    case 'Enter':
    case ' ':
      event.preventDefault();
      this.setActiveSub(this.subTabList[index]);
      return;

    default:
      return;
  }

  this.setActiveSub(this.subTabList[newIndex]);

  setTimeout(() => {
    this.subTabs.toArray()[newIndex].nativeElement.focus();
  });
}
setActiveSub(val: string) {
  this.resetData();
  this.activeTabSub = val;

  if (this.activeTab === 'nav') {
    this.getScheme();
  }

  this.getTableData();
}

onPlanOpened(opened: boolean) {
  if (opened) {
    setTimeout(() => {
      const firstOption = document.querySelector(
        '.mat-mdc-select-panel .mat-mdc-option'
      ) as HTMLElement;

      firstOption?.focus();
    }, 200);
  }
}

  onDateChanged = (event:any, val:string) => {
    let date = new Date(event.jsdate);
    if (event.jsdate === null) {
      date = new Date();
    }
    date.setDate(date.getDate() - 1);
    if (val === "from") {
      const obj = this.getCopyOfOptions(this.myDatePickerOptionsTo);
      obj.disableUntil = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      };
      this.myDatePickerOptionsTo = obj;
    } else {
      date.setDate(date.getDate() + 1);
      const obj = this.getCopyOfOptions(this.myDatePickerOptionsFrom);
      obj.disableSince = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      };
      this.myDatePickerOptionsFrom = obj;
    }
  };

  getCopyOfOptions(val:any): IMyOptions {
    return JSON.parse(JSON.stringify(val));
  }

  getCustomMonth = (val:any) => {
    const month = new Array();
    month[0] = "January";
    month[1] = "February";
    month[2] = "March";
    month[3] = "April";
    month[4] = "May";
    month[5] = "June";
    month[6] = "July";
    month[7] = "August";
    month[8] = "September";
    month[9] = "October";
    month[10] = "November";
    month[11] = "December";

    const parseDate = new Date(val);
    return (
      parseDate.getDate() +
      " " +
      month[parseDate.getMonth()] +
      " " +
      parseDate.getFullYear()
    );
  };

  public downloadXls() {
    const data = this.getFormatedData();
    this.exportExcel.exportAsExcelFile(
      data,
      `Latest_${this.activeTab}_${this.activeTabSub}`
    );
  }

  private getFormatedData(): any[] {
    const datePipe = new DatePipe("en-US");
    const decimalPipe = new DecimalPipe("en-US");

    const data = JSON.parse(JSON.stringify(this.data));
    for (const row of data) {
      if (row.date) {
        row.date = datePipe.transform(row.date, "dd MMM yyyy");
      }
      if (row.currentNav) {
        const currentNav = decimalPipe.transform(row.currentNav, "1.4-4");
        row.currentNav = `₹ ${currentNav}`;
      }
      if (row.previousNav) {
        const previousNav = decimalPipe.transform(row.previousNav, "1.4-4");
        row.previousNav = `₹ ${previousNav}`;
      }
      /*Divedents */
      if (row.recordDate) {
        row.recordDate = datePipe.transform(row.recordDate, "dd MMM yyyy");
      }
      if (row.corporate) {
        const corporate = row.corporate
        row.corporate = `₹ ${corporate}`;
      }
      if (row.individual) {
        const individual = row.individual
        row.individual = `₹ ${individual}`;
      }
      if (row.percentage) {
        const percentage = decimalPipe.transform(row.percentage, "1.2-2");
        row.percentage = `${percentage}`;
      }
       if (row.change) {
       const change = row.change;
         row.change = `₹ ${change}`;
       }
    }
    return data;
  }

  resetData = () => {
    this.userData.scheme = "All";
    this.userData.plan = "All";
    this.userData.fromDate = "";
    this.userData.toDate = "";
      this.schemeControl.setValue({scheme: 'All'});
  };

  getTableDataSubmit = () => {
    let url;
    if (this.activeTab === "nav") {
      if (this.activeTabSub === "current") {
        url = Urls.getCurrentNav;
      } else {
        url = Urls.getHistoricNav;
      }
    } else {
      if (this.activeTabSub === "current") {
        url = Urls.getCurrentDividend;
      } else {
        url = Urls.getHistoricDividend;
      }
    }

    if (this.activeTabSub === "current") {
      // delete this.userData.fromDate;
      // delete this.userData.toDate;
    } else {
      if (!this.userData.fromDate) {
        this.toastr.error(From_date);
        return;
      }
      if (!this.userData.toDate ) {
        this.toastr.error(To_date);
        return;
      }
    }
    
    if(this.userData.fromDate){
      // this.userData.fromDate = moment(this.userData.fromDate).set('hour', 12).toISOString();
    }
    if(this.userData.toDate){
      // this.userData.toDate = moment(this.userData.toDate).set('hour', 12).toISOString();
    }
    const requestData = JSON.parse(JSON.stringify(this.userData));
    if (this.userData.plan === "All") {
      requestData.plan = "";
    }
    if (this.userData.scheme === "All") {
      requestData.scheme = "";
      this.userData.plan = "All"
    }
    this.commonDataService.loaderStatus.next(true);
    this.apiService.postData(url, requestData).subscribe(
      response => {
        if(response.status === 0){
          this.data = response.data.returnList;
          if (this.data && this.data.length > 0) { this.liveMessage = `${this.data.length} records loaded based on selected filters.`; } else { this.liveMessage = 'No records found.'; }
          this.commonDataService.loaderStatus.next(false);
        }
      },
      error => {
        if(error.status === -1){
          this.data = [];
          this.liveMessage = 'No records found.';
          this.commonDataService.loaderStatus.next(false);
        }
      }
    )
  };

  displayFn(item:any): any | undefined {
    return item ? item.scheme : undefined;
  }

  showAllScheme() {
    this.filteredSchemeList= new Observable(ob => {ob.next(this.schemeList); })
  }
}
